import React from "react";
import {
    HeaderContainer,
    LoginButton,
    LogoTPHome,
} from "./HeaderComponent.styled";
import tnsLogo from "../../../assets/svg/tns-logo-2.0.svg";
import PropTypes from "prop-types";

const HeaderComponent = ({ handleLogin, showLogo = true }) => {
    return (
        <HeaderContainer>
            {showLogo && <LogoTPHome src={tnsLogo} alt="TP Trust&Safety" />}
            <LoginButton onClick={handleLogin}>Login</LoginButton>
        </HeaderContainer>
    );
};

export default HeaderComponent;

HeaderComponent.propTypes = {
    handleLogin: PropTypes.func.isRequired,
    showLogo: PropTypes.bool,
};
